import React from 'react';
import ReactDOM from 'react-dom/client';
import {I18nextProvider} from "react-i18next";
import i18next from "i18next";

import './index.css';

import App from './App';
import reportWebVitals from './reportWebVitals';
import {OAuthProvider} from "./context/OAuthContext";
import {ApplicationsTableProvider} from "./context/ApplicationsTableContext";
import {UserProvider} from "./context/UserContext";
import common_de from "./translations/de/common.json";

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);

i18next.init({
    interpolation: {escapeValue: false},  // React already does escaping
    lng: 'de',
    resources: {
        de: {
            common: common_de
        },
    },
});

root.render(
    <I18nextProvider i18n={i18next}>
        <OAuthProvider>
            <UserProvider>
                <ApplicationsTableProvider>
                    <React.StrictMode>
                        <App/>
                    </React.StrictMode>
                </ApplicationsTableProvider>
            </UserProvider>
        </OAuthProvider>
    </I18nextProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
